<template>
    <div class="my-site-view">
      <div class="nogame">
        抵制不良游戏，拒绝盗版游戏。 注意自我保护，谨防受骗上当。 适度游戏益脑，沉迷游戏伤身。 合理安排时间，享受健康生活。
      </div>
      <div class="content">
        <div class="content1">方寸之间，游戏人生</div>
        <div class="content2">Time is always with the people who
          have courage to fly,not with the people
          who stand and watch the sky.</div>

<!--        <div class="content3">-->
<!--          <img class="corp-name" src="../assets/jpdesign.png"/>-->
<!--        </div>-->
      </div>
    </div>
</template>

<script>
export default {
  name: 'mysite'
}
</script>

<style scoped>
  .my-site-view{
    width: 100%;
    flex-grow: 1;
    background: url("../assets/mysite-bg.jpg") no-repeat fixed top;
    background-size: cover;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    align-items: center;
    display: flex;
    position: relative;
  }
  .content{
    margin-left: 30%;
    flex-direction: column;
    justify-content: center;
    align-content: flex-start;
    align-items: flex-start;
    display: flex;
    position: relative;
  }
  .content1{
    font-size:3.13rem;
    font-weight:bold;
    line-height:4.13rem;
    color:rgba(255,255,255,1);
  }
  .content2{
    margin-top: 5%;
    width:58.5rem;
    height:9.5rem;
    font-size:2.5rem;
    font-family:Orator Std;
    font-weight:400;
    line-height:3.5rem;
    color:rgba(255,255,255,1);
  }
  .nogame{
    position: absolute;
    bottom: 5%;
    right: 0;
    margin-top: 5%;
    width:29rem;
    height:9.5rem;
    font-size:1rem;
    font-weight:400;
    line-height:3.5rem;
    color:rgba(255,255,255,1);
  }
  .content3{
    width: 100%;
    flex-direction: column;
    justify-content: flex-end;
    align-content: flex-end;
    align-items: flex-end;
    display: flex;
    position: relative;
  }
  .corp-name{
    transform: scale(0.7);
  }
</style>



// WEBPACK FOOTER //
// src/components/mysite.vue